import { ManagementTenant, User } from '@xeetr/types/models'
import { useState } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import RequireAuth from '../../components/commons/RequireAuth'
import Error from '../../pages/common/Error'

import { ActiveTenantContext, ActiveUserContext } from './Context'



export const ContextProvider = () => {
  const [activeTenant, setActiveTenant] = useState<ManagementTenant | undefined>()
  const [activeUser, setActiveUser] = useState<User | undefined>()
  const [selectedTenantId, setSelectedTenantId] = useState('')

  const setTenantId = (id: string) => {
    setSelectedTenantId(id)
    sessionStorage.setItem('tenantId', id)
  }

  return (
    <ErrorBoundary FallbackComponent={Error}>
      <ActiveUserContext.Provider value={{ user: activeUser, setUser: setActiveUser }}>
        <ActiveTenantContext.Provider
          value={{
            tenant: activeTenant,
            setTenant: setActiveTenant,
            tenantId: selectedTenantId,
            setTenantId,
          }}
        >
          <RequireAuth />
        </ActiveTenantContext.Provider>
      </ActiveUserContext.Provider>
    </ErrorBoundary>
  )
}
